import { Box, Header } from '@rbilabs/universal-components';

import Link from 'components/link';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { theme } from 'styles/configure-theme';

export const Container = Box.withConfig({
  marginTop: '$0',
  marginX: '$3',
  marginBottom: '$8',
});

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  marginTop: '$0',
  marginX: 'auto',
  marginBottom: '$8',
  paddingY: '$0',
  paddingX: '$6',
  width: 'full',
  height: '$16',
});

export const Headline = Header.withConfig({
  variant: 'headerOne',
  textAlign: 'center',
  marginBottom: '$5',
});

export const SignIn = Link.withConfig({
  color: theme.token('text-link-default'),
  _text: {
    variant: 'headerThree',
    margin: '$0',
  },
  textDecoration: 'none',
  marginLeft: '$1',

  _hover: {
    color: theme.token('text-link-hover'),
  },
});
